import { useState } from 'react'
import { Box, MenuItem, Select, Typography } from '@mui/material'
import { i18n } from '@lingui/core'
import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from '../consts/default-locale'
import {
  dispatchConfigLocaleChanged,
} from '../utils/config-localization'

/** Etichette fisse nella lingua nativa (non tradotte al cambio locale). */
const LANGUAGE_LABELS = {
  en: 'Eng',
  es: 'Esp',
  fr: 'Fra',
  ru: 'Рус',
  tg: 'Тоҷ',
}

function readStoredLanguage() {
  const stored = localStorage.getItem('preferredLanguage')
  if (stored && SUPPORTED_LOCALES.includes(stored)) return stored
  return DEFAULT_LOCALE
}

export const LanguageSwitcher = () => {
  const [lang, setLang] = useState(readStoredLanguage)

  const changeLanguage = lng => {
    setLang(lng)
    i18n.activate(lng)
    localStorage.setItem('preferredLanguage', lng)
    dispatchConfigLocaleChanged(lng)
  }

  return (
    <Box position='absolute' top={0} right={32} mt={2} ml={2}>
      <Select
        value={lang}
        onChange={e => changeLanguage(e.target.value)}
        renderValue={value => (
          <Typography
            component="span"
            sx={{
              fontWeight: 600,
              fontSize: '0.875rem',
              color: '#333',
            }}
          >
            {LANGUAGE_LABELS[value]}
          </Typography>
        )}
        sx={{
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(8px)',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
          borderRadius: '8px',
          minWidth: '60px',
          '& .MuiOutlinedInput-notchedOutline': {
            border: '1px solid rgba(0, 0, 0, 0.1)',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: '1px solid rgba(0, 0, 0, 0.2)',
          },
          '& .MuiSelect-select': {
            padding: '8px 32px 8px 12px',
            fontWeight: 600,
            fontSize: '0.875rem',
            color: '#333',
          },
        }}
        MenuProps={{
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'right',
          },
          PaperProps: {
            sx: {
              bgcolor: 'rgba(255, 255, 255, 0.98)',
              backdropFilter: 'blur(8px)',
              boxShadow: '0 4px 16px rgba(0, 0, 0, 0.2)',
              borderRadius: '8px',
              marginTop: '4px',
              minWidth: '60px',
              '& .MuiMenuItem-root': {
                padding: '10px 16px',
                borderRadius: '4px',
                margin: '4px',
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.08)',
                },
              },
            },
          },
        }}
      >
        {SUPPORTED_LOCALES.map(code => (
          <MenuItem key={code} value={code}>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: '0.875rem',
                color: '#333',
              }}
            >
              {LANGUAGE_LABELS[code]}
            </Typography>
          </MenuItem>
        ))}
      </Select>
    </Box>
  )
}
